import React from "react";
import {Route, Routes} from "react-router-dom";

import withAuth from "Hoc/withAuth.js";
import withFeatures from "Hoc/withFeatures.js";
import wrapRoute from "Wrappers/RouteWrapper.js";

import Ui404View from "./Ui404View.js";
import UiRoutes from "./UiRoutes.js";

/**
 * UI router
 *
 * The main application router.
 * 
 * @package HOPS
 * @subpackage Ui
 * @copyright Heritage Operations Processing Limited
 */
const UiRouter = ({authedAny, isFeatureEnabled}) => {

	const getRouteWrapper = route => {
		if (!route.wrapped) {
			route.wrapped = wrapRoute(route);
		}
		return route.wrapped;
	};

	return (
		<Routes>
			{UiRoutes.map(route => {

				if (route.feature && !isFeatureEnabled(route.feature)) {
					return null;
				}
				else if (route.publicOnly && authedAny) {
					return null;
				}

				return (
					<Route
						Component={getRouteWrapper(route)}
						key={route.uri}
						index={route.index}
						path={`${route.uri}${route.inexact ? "/*" : ""}`} />
				);

			})}

			{/** Catchall 404 route, even if no routes are declared */}
			<Route path="*" element={<Ui404View />}/>
		</Routes>
	);

};

export default withAuth(withFeatures(UiRouter));
